export default __webpack_public_path__ + "static/media/(85).c1b35e79.jpg";